<template>
  <div>
    <Header></Header>

    <div id="main">

      <div class="container">

        <article class="how-top text-center">
          <h1>Como Funciona</h1>
          <p>Somos uma plataforma online e GRATUITA feita para promover o bem. Você pode ajudar ou buscar ajuda para arrecadar doações à uma causa.</p>
        </article>

        <article class="assista-video">
          <h4>Assista ao vídeo</h4>
          <div class="video">
            <div class='embed-container'>
              <iframe :src="video" frameborder='0' allowfullscreen></iframe>
            </div>
          </div>
        </article>

        <article class="primeiro-passo">
          <h4>Primeiro passo</h4>
          <h1>Cadastre sua Organização Social</h1>
          <p>Nosso sistema é simples e fácil. Conte sua história!</p>
          <div class="pass">
            <img alt="Video" :src="pass1">
          </div>
        </article>

        <article class="primeiro-passo">
          <h4>Segundo passo</h4>
          <h1>Compartilhe e divulgue</h1>
          <p>Tornamos simples compartilhar seu projeto no Facebook e e-mail.</p>
          <div class="pass">
            <img alt="Video" :src="pass3">
          </div>
        </article>

        <article class="primeiro-passo">
          <h4>Terceiro passo</h4>
          <h1>Receba doações facilmente</h1>
          <p>Receba as doações através de diferentes meios de pagamento</p>
          <div class="facil">
            <img alt="Video" :src="pass4">
          </div>
        </article>

        <article class="primeiro-passo">
          <h4>Quarto passo</h4>
          <h1>Atualize seus seguidores</h1>
          <p>Deixe seus doadores sempre atualizados com novidades e o progresso de sua Organização Social. </br>Eles gostam de saber que ajudaram :)</p>
          <div class="pass">
            <img alt="Video" :src="pass2">
          </div>
        </article>

        <article class="how-btm text-center">
          <h1>Cadastre sua Organização Social</h1>
          <p>Diferentemente de outras plataformas de doação, a nossa é totalmente gratuita. Queremos garantir que toda doação vá direto a quem mais precisa.</p>
          <router-link to="/login">Cadastre Agora</router-link>
        </article>

      </div>

    </div>
    
    <Footer></Footer>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import pass1 from '../assets/images/pass.png'
import pass2 from '../assets/images/pass-2.png'
import pass3 from '../assets/images/meu.png'
import pass4 from '../assets/images/facil.png'

export default {
  name: 'AboutUs',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      pass1: pass1,
      pass2: pass2,
      pass3: pass3,
      pass4: pass4,
      video: 'https://www.youtube.com/embed/FZqASWupsFI?rel=0&amp;controls=0&amp;showinfo=0'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#main{
  padding-top: 96px;
}

  h4{
    position: relative;
    margin: 50px 0px;
    color: #00ae39;
    font-size: 22pt;
    text-align: center;
    font-family: RalewayBold;

    &::before{
      position: absolute;
      content: " ";
      width: 35%;
      border-bottom: 1px solid #d9d9d9;
      height: 1px;
      top: 50%;
      right: 0;
    }

    &::after{
      position: absolute;
      content: " ";
      width: 35%;
      border-bottom: 1px solid #d9d9d9;
      height: 1px;
      top: 50%;
      left: 0;
    }
  }

  .how-top{
    padding: 30px 0px;
    background: #F3F3F3;

    h1{
      font-family: RalewayBold;
    }

    p{
      display: block;
      padding: 10px;
      font-size: 22px;
    }
  }

  .primeiro-passo{
    color: #434343;
    font-size: 18pt;
    text-align: center;
    font-weight: 100;
    margin-bottom: 40px;
  }

  .how-btm {
    margin-top: 50px;
    padding: 50px 0px;
    background: #00AE39;
    color: #fff;

    h1{
      font-family: RalewayBold;
    }

    p{
      font-size: 22px;
      padding: 10px;
    }

    a{
      padding: 10px;
      border: thin solid #fff;
      color: #fff;
      text-decoration: none;
      cursor: pointer;
      font-size: 22px;
      border-radius: 5px;
    }
  }

  .embed-container {
    position: relative; 
    padding-bottom: 56.25%; 
    height: 0; 
    overflow: hidden; 
    max-width: 100%; 
  } 
  .embed-container iframe, .embed-container object, .embed-container embed {
    position: absolute;
    top: 0; 
    left: 0; 
    width: 100%; 
    height: 100%; 
  }

</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue